import { render, staticRenderFns } from "./add-cell.vue?vue&type=template&id=5772ed84&scoped=true&"
import script from "./add-cell.vue?vue&type=script&lang=js&"
export * from "./add-cell.vue?vue&type=script&lang=js&"
import style0 from "./add-cell.vue?vue&type=style&index=0&id=5772ed84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5772ed84",
  null
  
)

export default component.exports